import {
    Box,
} from "@mui/material";
import { AllHolidaysInterface } from "../../interface/allHolidaysInterface";
import { useState } from "react";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import HolidayTableItem from './HolidayTableItem'
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }
  
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

interface CellNamesParams {
    cellOne: string;
    cellTwo: string;
    cellTree: string;
    cellFour: string;
    cellFive: string;
    cellSix: string;
    cellSeven: string;
    cellEight: string;
    cellNine: string;
}

interface HolidaysTableParams {
    data: AllHolidaysInterface[];
    cellNames: CellNamesParams;
    setAllHolidays: React.Dispatch<
        React.SetStateAction<AllHolidaysInterface[]>
    >;
}
const HolidaysTable = ({
    data,
    cellNames,
    setAllHolidays,
}: HolidaysTableParams) => {
    const [value, setValue] = useState(0);
    console.log(setAllHolidays);
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
        console.log(event);
    };

    return (
        <>
            <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab label="Pending" {...a11yProps(0)} />
                <Tab label="Approved" {...a11yProps(1)} />
                <Tab label="Declined" {...a11yProps(2)} />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                <HolidayTableItem data={data.filter(item => item.status === 0)} cellNames={cellNames} setAllHolidays={setAllHolidays} ></HolidayTableItem>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <HolidayTableItem data={data.filter(item => item.status === 1)} cellNames={cellNames} setAllHolidays={setAllHolidays} ></HolidayTableItem>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
                <HolidayTableItem data={data.filter(item => item.status === 2)} cellNames={cellNames} setAllHolidays={setAllHolidays} ></HolidayTableItem>
            </CustomTabPanel>
            </Box>
        </>
    );
};

export default HolidaysTable;
